import {Component, type ErrorInfo, type ReactNode} from 'react'
import {CircleAlert, RotateCcw} from 'lucide-react'
import {Button} from '@/components/ui/Button'

interface Props {children: ReactNode}
interface State {error: Error | null}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = {error: null}

  static getDerivedStateFromError(error: Error): State {
    return {error}
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ui-error-boundary]', error, info.componentStack)
  }

  private reset = () => this.setState({error: null})

  render() {
    if (!this.state.error) return this.props.children
    return <main className="app-error-shell"><section className="app-error-card" role="alert"><CircleAlert aria-hidden="true"/><span className="eyebrow">WORKSPACE ERROR</span><h1>工作台暂时遇到问题</h1><p>当前页面没有丢失已保存的数据。可以先重新加载界面；如果问题持续，请把错误时间和操作步骤交给管理员。</p><div className="app-error-actions"><Button variant="primary" onClick={() => window.location.reload()}><RotateCcw aria-hidden="true"/>重新加载</Button><Button onClick={this.reset}>返回当前页面</Button></div><small>{this.state.error.message}</small></section></main>
  }
}
